import React, { useEffect, useState } from "react"
import Markdown from "react-markdown"
import remarkGfm from "remark-gfm"

import { WebSource } from "../../../../../../model/types"
import api from "../../../../../../services/api"
import { sourceMarkdownUrl } from "../../source_content"

export default function SourceMarkdownView({
  source,
  className = "",
}: {
  source: WebSource
  className?: string
}) {
  const [markdown, setMarkdown] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setMarkdown(null)
    setError(null)

    api()
      .get(sourceMarkdownUrl(source))
      .then((response) => {
        if (cancelled) return
        setMarkdown(response.data?.markdown || null)
        setError(response.data?.error || null)
      })
      .catch(() => {
        if (cancelled) return
        setError("Could not load extracted text")
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [source.id])

  return (
    <div className={`min-h-0 grow overflow-auto p-4 md:p-8 ${className}`}>
      {loading ? (
        <div className="text-sm text-gray-500 dark:text-gray-400">Loading extracted text…</div>
      ) : error && !markdown ? (
        <div className="text-sm text-amber-800 dark:text-amber-200">{error}</div>
      ) : (
        <div
          className="prose dark:prose-invert prose-sm md:prose-base max-w-none break-words"
          data-testid="source-extracted-markdown"
        >
          <Markdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ href, children }) => (
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {children}
                </a>
              ),
            }}
          >
            {markdown || ""}
          </Markdown>
        </div>
      )}
    </div>
  )
}
